import { useCallback, useRef } from 'preact/hooks'
import { MDCCheckbox } from '@material/checkbox'
import clsx from 'clsx'
import { JSX } from 'preact'

type HTMLAttributeProps = JSX.HTMLAttributes & {
  [key: `data-${string}`]: string
}

type PreactCheckboxProps = {
  onChange: (event: unknown) => void
  children?: unknown
  label?: string
  className?: string
  id?: string
  inputProps?: HTMLAttributeProps
  labelProps?: HTMLAttributeProps
  isDisabled?: boolean
  isChecked?: boolean
  isError?: boolean
}

export default function PreactCheckbox({onChange, children, label, className='', id, inputProps, labelProps, isDisabled=false, isChecked=false, isError=false}: PreactCheckboxProps) {
  const ref = useRef<MDCCheckbox | null>(null)
  if(id === undefined) {
    id = `${label}-checkbox`
  }

  const setRef = useCallback(select => {
    if(ref.current) {
      ref.current.destroy()
    }
    if(select) {
      ref.current = new MDCCheckbox(select)
    } else {
      ref.current = null
    }
  }, [])

  return (
    <div className={clsx("preact-checkbox-container", className, isError && "error")}>
      <div className={clsx("preact-checkbox", "mdc-checkbox", isDisabled && "mdc-checkbox--disabled")} ref={setRef}>
        <input type="checkbox" id={id} className="mdc-checkbox__native-control" disabled={isDisabled} checked={isChecked} onClick={(event) => onChange(event)} {...inputProps} />
        <div className="mdc-checkbox__background">
          <svg className="mdc-checkbox__checkmark" viewBox="0 0 24 24">
            <path className="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
          </svg>
          <div className="mdc-checkbox__mixedmark"></div>
        </div>
        <div className="mdc-checkbox__ripple"></div>
        <div className="mdc-checkbox__focus-ring"></div>
      </div>
      <label htmlFor={id} {...labelProps}>{label ?? children ?? ''}</label>
    </div>
  )
}
